import React, {useEffect, useState} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import PageLayout from '../components/PageLayout';
import axios from 'axios';
import Footer from '../components/Footer';

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 24px;
  background: #fff;
  display: flex;
  justify-content: center;
`;

const ProductContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  padding: 48px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 24px;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 1;
  background: #f0f0f0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0;
`;

const Price = styled.p`
  font-size: 1.5rem;
  color: #c41e3a;
  font-weight: 500;
  margin: 0;
`;

const Description = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #333;
`;

const Details = styled.div`
  font-size: 1rem;
  color: #666;
  border-top: 1px solid #eee;
  padding-top: 24px;
`;

const SpecList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 8px 0;

  li {
    margin-bottom: 8px;
    display: flex;
    align-items: flex-start;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const SpecLabel = styled.span`
  font-weight: 500;
  min-width: 100px;
  margin-right: 16px;
  color: #333;
`;

const MaterialsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;

const MaterialTag = styled.span`
  background: #f5f5f5;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.9rem;
  color: #666;
`;

const BackButton = styled.button`
  position: fixed;
  top: 24px;
  left: 240px;
  background: none;
  border: none;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  cursor: pointer;
  color: #000;
  padding: 8px 16px;
  transition: all 0.3s ease;

  &:hover {
    color: #c41e3a;
  }
`;

const Watermark = styled.div`
  position: fixed;
  bottom: -1rem;
  left: 2rem;
  font-size: 8vw;
  font-weight: bold;
  color: rgba(196, 30, 58, 0.05);
  z-index: 0;
  animation: float 6s ease-in-out infinite;

  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-20px); }
    100% { transform: translateY(0px); }
  }
`;

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`http://localhost:8000/products/${id}`)
      .then(response => {
        setProduct (response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <PageLayout>
        <Container>
          <h1>Loading...</h1>
        </Container>
      </PageLayout>
    );
  }

  if (!product) {
    return (
      <PageLayout>
        <Container>
          <BackButton onClick={() => navigate('/shop')}>← Back to Shop</BackButton>
          <h1>Product not found</h1>
        </Container>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Container>
        <Watermark>442</Watermark>
        <ProductContainer>
          <BackButton onClick={() => navigate('/shop')}>← Back to Shop</BackButton>
          <ImageContainer>
            <img src={product.image} alt={product.name} />
          </ImageContainer>
          <InfoContainer>
            <Title>{product.name}</Title>
            <Price>${product.price.toFixed(2)}</Price>
            {product.description && (
              <Description>{product.description}</Description>
            )}
            {/* <Details>
              <SpecList>
                {product.color && (
                  <li>
                    <SpecLabel>Color</SpecLabel>
                    {product.color}
                  </li>
                )}
                {product.details && (
                  <li>
                    <SpecLabel>Details</SpecLabel>
                    {product.details}
                  </li>
                )}
                {product.edition && (
                  <li>
                    <SpecLabel>Edition</SpecLabel>
                    {product.edition}
                  </li>
                )}
                {product.materials && (
                  <li>
                    <SpecLabel>Materials</SpecLabel>
                    <MaterialsList>
                      {product.materials.map((material, index) => (
                        <MaterialTag key={index}>{material}</MaterialTag>
                      ))}
                    </MaterialsList>
                  </li>
                )}
              </SpecList>
            </Details> */}
          </InfoContainer>
        </ProductContainer>
        <Footer />
      </Container>
    </PageLayout>
  );
};

export default ProductDetail; 